import * as React from "react";

const SvgCMSFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="currentColor"
  >
    <g clipPath="url(#clip0_13050_1845)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.01172 2C4.01172 0.895431 4.90715 0 6.01172 0H14.9883C16.0929 0 16.9883 0.895431 16.9883 2V18C16.9883 19.1046 16.0929 20 14.9883 20H6.01172C4.90715 20 4.01172 19.1046 4.01172 18V2ZM0.5 4.75C0.5 4.33579 0.835786 4 1.25 4C1.66421 4 2 4.33579 2 4.75V15.25C2 15.6642 1.66421 16 1.25 16C0.835786 16 0.5 15.6642 0.5 15.25V4.75ZM19.75 4C19.3358 4 19 4.33579 19 4.75V15.25C19 15.6642 19.3358 16 19.75 16C20.1642 16 20.5 15.6642 20.5 15.25V4.75C20.5 4.33579 20.1642 4 19.75 4Z"
        fill="currentColor"
      />
      <line
        x1="9.25"
        y1="15.3655"
        x2="11.75"
        y2="15.3655"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.5 5.25H15.5"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13050_1845">
        <rect
          width="1em"
          height="1em"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCMSFilled;
